import {BaseService} from "./base.service";

class ImportSubsidiaryFileService extends BaseService {

    constructor() {
        super('api/import-file')
    }

}

export const importsubsidiaryfileService = new ImportSubsidiaryFileService();
